import { Location } from 'history'
import queryString from 'query-string'
import {
  createBudgetUrl,
  createVirtualCardUrl,
  homeUrl,
} from 'src/navigation/urls'
import { LocationState } from 'src/redux/createRootReducer'

const generateLocationWithSearch = (
  url: string,
  queryParams?: Record<string, string | string[] | undefined>,
): Location<LocationState> => ({
  pathname: url,
  state: {},
  hash: '',
  search: queryParams !== undefined ? queryString.stringify(queryParams) : '',
})

export const createVirtualCardLocation = (
  queryParams: Record<string, string | string[] | undefined>,
): Location<LocationState> =>
  generateLocationWithSearch(createVirtualCardUrl(), queryParams)

export const createBudgetLocation = (
  queryParams: Record<string, string | string[] | undefined>,
): Location<LocationState> =>
  generateLocationWithSearch(createBudgetUrl(), queryParams)

export const homeLocation = (): Location<LocationState> =>
  generateLocationWithSearch(homeUrl())
